var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"170px"}},[_c('v-select',{staticClass:"text-caption",attrs:{"items":_vm.listaOrdenacao,"value":_vm.ordenacao_selected,"label":"Escolher ordem","item-value":"id","item-text":"label","clearable":"","outlined":"","dense":"","hide-details":""},on:{"input":_vm.onOrdenacaoChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }